/**
 * VendorPortalProductTypeService
 * Service for reading product types via vendor portal (read-only).
 * Route: api/vendor-portal/product-types
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalProductTypeService
 * Provides read-only access to product type reference data for vendors.
 * Maps to /api/vendor-portal/product-types endpoint
 */
export class VendorPortalProductTypeService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalProductTypeService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalProductTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ====================
    /**
     * Get all active product types available for vendors.
     * GET /api/vendor-portal/product-types
     * Returns only active product types.
     */
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    /**
     * Get all active product types (raw response)
     */
    getAllRaw() {
        return this.get();
    }
    // ==================== GET BY ID ====================
    /**
     * Get a specific product type by ID.
     * GET /api/vendor-portal/product-types/{id}
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Product type with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a specific product type (raw response)
     */
    getByIdRaw(id) {
        return this.get(String(id));
    }
}
VendorPortalProductTypeService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorPortalProductTypeService.BASE_PATH = 'api/vendor-portal/product-types';
//# sourceMappingURL=VendorPortalProductTypeService.js.map